/**
@ngdoc directive
@name xmsTabs

@description
The tabs will be placed just after <xms-tabs> opening tag.<br/>
You can place id or other html attributes on <xms-tabs>.

@usage
<xms-tabs ng-model="pageModel.tabs2" ng-init="pageModel.tabs2='two'">
    <div xms-tabs-pane="one" header="Tab 1">
        <p>Tab content 1</p>
    </div>
    <div xms-tabs-pane="two" header="Tab 2">
        <p>Tab content 2</p>
    </div>
    <div xms-tabs-pane="three" header="Tab 3">
        <p>Tab content 3</p>
    </div>
    <div xms-tabs-pane="four" header="Disabled tab" disabled>
        <p>Disabled tab content</p>
    </div>
    <div xms-tabs-pane="five" header="Dynamically disabled" ng-disabled="{{formModel.disableTab}}">
        <p>Dynamically disabled tab content</p>
    </div>
</xms-tabs>
*/

(function() {
    'use strict';

var xmsTabs = function($templateCache) {
    return {
        restrict: 'EA',
        replace: true,
        scope: true,
        bindToController: {
            ngModel: '='
        },
        controllerAs: 'ctrl',
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            var _this = this;
            _this.tabs = {};
            _this.tabCount = 0;

            this.registerTab = function(tabName, header, disabled) {
                _this.tabs[tabName] = {name:tabName, header:header, disabled:disabled};
                _this.tabCount++;
            };
            this.disableTab = function(tabName){
                _this.tabs[tabName].disabled = true;
            };
            this.enableTab = function(tabName) {
                _this.tabs[tabName].disabled = false;
            };
        }],
        transclude: true,
        template: $templateCache.get('components/xmsTabs.html')
    };
}
xmsTabs.$inject = ['$templateCache'];
angular.module('app').directive('xmsTabs', xmsTabs);



var xmsTabsPane = function() {
    return {
        restrict: 'EA',
        replace: true,
        scope: true,
        require: '^xmsTabs',
        transclude: true,
        template: '<div ng-show="ctrl.ngModel == tabName" aria-hidden="{{ctrl.ngModel!=tabName}}" aria-expanded="{{ctrl.ngModel==tabName}}" role="tabpanel" ng-transclude></div>',
        link: {
            pre: function (scope, elem, attrs, ctrl) {
                scope.ctrl = ctrl; // for template
                scope.tabName = attrs.xmsTabsPane;
                ctrl.registerTab(attrs.xmsTabsPane, attrs.header, angular.isDefined(attrs.disabled) );
            },
            post: function(scope, elem, attrs, ctrl){

                if( angular.isDefined(attrs.ngDisabled) ){
                    // we may want to introduce the xmsTabPane controller and watch on ngDisabled instead of $observe
                    attrs.$observe('ngDisabled', function(val) {
                        if(val==='true'){ // evaluated attribute is a string
                            ctrl.disableTab(attrs.xmsTabsPane);
                        } else {
                            ctrl.enableTab(attrs.xmsTabsPane);
                        }
                    });
                }

            }
        }
    };
}
angular.module('app').directive('xmsTabsPane', xmsTabsPane);


}());

